import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ArrowUpRight } from 'lucide-react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0a0a0a] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_portfolio-site-106/artifacts/kfpt7w0i_logo%20heter.png" 
                alt="Side Kraft Logo" 
                className="h-14 w-auto"
              />
            </Link>
            <p className="font-manrope text-white/70 mt-6 text-sm leading-relaxed">
              Vi hjelper norske bedrifter med å vokse digitalt gjennom profesjonelle nettsider, SEO og målrettet annonsering.
            </p>
          </div>

          {/* Tjenester */}
          <div>
            <h4 className="font-syne font-bold text-sm uppercase tracking-wider mb-6 text-white">
              Tjenester
            </h4>
            <ul className="space-y-3">
              {[
                { name: 'Ny nettside', href: '/tjenester/nettside' },
                { name: 'Annonsering', href: '/tjenester/annonsering' },
                { name: 'SEO', href: '/tjenester/seo' },
                { name: 'Nettbutikk', href: '/tjenester/nettbutikk' },
                { name: 'Logodesign', href: '/tjenester/logodesign' },
                { name: 'Google Bedriftsprofil', href: '/tjenester/google-bedriftsprofil' },
              ].map((item) => (
                <li key={item.href}>
                  <Link 
                    to={item.href} 
                    className="font-manrope text-sm text-white/70 hover:text-accent transition-colors duration-300 flex items-center gap-1 group"
                    data-testid={`footer-${item.href.split('/').pop()}`}
                  >
                    {item.name}
                    <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Sider */}
          <div>
            <h4 className="font-syne font-bold text-sm uppercase tracking-wider mb-6 text-white">
              Selskapet
            </h4>
            <ul className="space-y-3">
              {[
                { name: 'Om oss', href: '/om-oss' },
                { name: 'Prosjekter', href: '/prosjekter' },
                { name: 'Blogg', href: '/blogg' },
                { name: 'Ta kontakt', href: '/kontakt' },
                { name: 'Personvern', href: '/personvern' },
                { name: 'Vilkår', href: '/vilkar' },
              ].map((item) => (
                <li key={item.href}>
                  <Link 
                    to={item.href} 
                    className="font-manrope text-sm text-white/70 hover:text-accent transition-colors duration-300 flex items-center gap-1 group"
                    data-testid={`footer-${item.href.replace('/', '')}`}
                  >
                    {item.name}
                    <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Kontakt */}
          <div>
            <h4 className="font-syne font-bold text-sm uppercase tracking-wider mb-6 text-white">
              Kontakt
            </h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:+4740081956" 
                  onClick={(e) => {
                    e.preventDefault();
                    if (typeof window.gtag_report_conversion === 'function') {
                      window.gtag_report_conversion('tel:+4740081956');
                    } else {
                      window.location.href = 'tel:+4740081956';
                    }
                  }}
                  className="font-manrope text-sm text-white/70 hover:text-accent transition-colors duration-300 flex items-center gap-3"
                  data-testid="footer-phone"
                >
                  <Phone className="w-4 h-4" />
                  +47 400 81 956
                </a>
              </li>
              <li>
                <a 
                  href="mailto:post@sidekraft.no" 
                  className="font-manrope text-sm text-white/70 hover:text-accent transition-colors duration-300 flex items-center gap-3"
                  data-testid="footer-email"
                >
                  <Mail className="w-4 h-4" />
                  post@sidekraft.no
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/70">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span className="font-manrope text-sm">
                  Oslo, Norge
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-manrope text-xs text-white/50">
            © {currentYear} Side Kraft. Alle rettigheter reservert.
          </p>
          <div className="flex gap-6">
            <Link to="/personvern" className="font-manrope text-xs text-white/50 hover:text-accent transition-colors duration-300">
              Personvern
            </Link>
            <Link to="/vilkar" className="font-manrope text-xs text-white/50 hover:text-accent transition-colors duration-300">
              Vilkår
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
